import { gql, useApolloClient } from "@apollo/client";
import { useGetCurrentPatientLazyQuery } from "../generated/graphql";
import { useCallback } from "react";

export const GET_CURRENT_PATIENT_GQL = gql`
  query GetCurrentPatient($patientShortId: String!) {
    patientInfo(patientShortId: $patientShortId) {
      preferredName
    }
  }
`;

/**
 * Custom hook to lazily fetch the current patient as well as refetch all
 * active queries on successful response.
 *
 * @returns A tuple containing an Apollo client function to fetch the current
 * patient and the result of the lazy query.
 */
export function useGetCurrentPatientQueryCallbackWithRefetch() {
  const client = useApolloClient();
  const [fetch, { ...result }] = useGetCurrentPatientLazyQuery();
  const fetchWithRefetch = useCallback(
    async (...args: Parameters<typeof fetch>) => {
      const response = await fetch(...args);
      if (response.data?.patientInfo) {
        await client.refetchQueries({ include: "active" });
      }
      return response;
    },
    [fetch, client],
  );
  return [fetchWithRefetch, result] as const;
}
